module.exports = __webpack_public_path__ + "img/emoji_tbkx.7a44dfdc.png";